<template lang="pug">
footer
    .footer-inner
        .pull-left
            //- span.current-year
            //- span.text-bold.text-uppercase  Salesbeat
            //- | . 
            span Вопросы? Пишите нам — <a href="mailto:hi@salesbeat.pro">hi@salesbeat.pro</a>
        .pull-right
            span.go-top
                i.ti-angle-up

</template>

<script>
    export default {
        name: 'Footer'
    };
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue